export default __webpack_public_path__ + "static/media/Screenshot_20.9df599bd.png";